import { render, staticRenderFns } from "./DeleteSoundPopup.vue?vue&type=template&id=28fe61b0&scoped=true"
import script from "./DeleteSoundPopup.vue?vue&type=script&lang=ts"
export * from "./DeleteSoundPopup.vue?vue&type=script&lang=ts"
import style0 from "./DeleteSoundPopup.vue?vue&type=style&index=0&id=28fe61b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe61b0",
  null
  
)

export default component.exports